export type Adapter<
  A,
  B,
  keysT extends keyof toAdaptersT,
  toAdaptersT extends {
    [key in keysT]: (a: A) => unknown
  },
> = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  from: (b: B, ...args: any[]) => A
} & toAdaptersT

export const makeAdapter = <
  A,
  B,
  keysT extends keyof toAdaptersT,
  toAdaptersT extends {
    [key in keysT]: (a: A) => unknown
  },
>(
  adapters: Adapter<A, B, keysT, toAdaptersT>,
) => adapters
